angular.module('impactx.profile').controller('ProfileCtrl', [
    '$scope',
    '$redirect',
    'dataGen',
    '$context',
    '$mdToast',
    '$mdDialog',
    '$workspace',
    'TranslationService',
    'PaginationService',
    'ToolbarService',
    'ConfirmationService',
    'LoginService',
    ProfileController
]);

function ProfileController($scope, $redirect, dataGen, $context, $mdToast, $mdDialog, $workspace, TranslationService, PaginationService, ToolbarService, ConfirmationService, LoginService) {
    var self = this;
    $scope.searchText = "";
    $scope.selectedItems = [];
    $scope.searchTextDelegates = "";
    $scope.allSetting = {};

    self.getPageData = function () {
        dataGen.getData($scope, {}, "/profile/view").then(function () {
            $scope.labelMoveUp = TranslationService.get("moveUp");
            $scope.labelMoveDown = TranslationService.get("moveDown");
            defineButtons();
            angular.forEach($scope.data.messageSettings.configMessages, function(entry) {
                $scope.allSetting[entry.configView.viewType] = {value: null};
            })
        })
    };
    self.getPageData();

    self.save = function () {
        // clear delegation user before saving the dialog
        angular.forEach($scope.data.userdelegate, function (delegation) {
            delegation.delegates.entries = [];
        });
        var dataObj;
        if ($scope.croppedImage) {
            dataObj = {
                data: $scope.data,
                img: $scope.croppedImage
            };
        }
        else {
            dataObj = {
                data: $scope.data
            };
        }

        return dataGen.post({}, dataObj, "/profile/save").then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            $context.refreshUser({}, dataGen, $context);
            PaginationService.setNumberOfLines(impactX.isDefined($scope, 'data.user.numberOfLinesForLists.selected.value'));
            if ($scope.data.workspaces) {
                $context.invalidateSidebar(dataGen, $context, $workspace);
            }
            $redirect.redirectTo(null, "fallbackstartpage");
        });
    };

    self.editAddressPreferences = function (ev) {
        $mdDialog.show({
            controller: 'AddressPreferencesDialogCtrl',
            controllerAs: 'ctrl',
            templateUrl: 'modules/profile/templates/address-preferences.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                addressField: angular.copy($scope.data.useraddress.addressField, {}),
                translations: $scope.trns
            }
        }).then(function (response) {
            $scope.data.useraddress.addressField.addressFields = response.possible;
            $scope.data.useraddress.addressField.selected = response.selected;
        });
    };

    self.deleteImportantMenuItem = function (workspace, index) {
        workspace.importantMenuItems.splice(index, 1);
        for (var i = 0; i < workspace.importantMenuItems.length; i++) {
            workspace.importantMenuItems[i].xorder = i;
        }
    };

    self.openAddImportantMenuItemDialog = function (ev, workspace, selectedItem) {
        $mdDialog.show({
            controller: 'AddImportantMenuItemDialogCtrl',
            controllerAs: 'addImportantMenuItemDialogCtrl',
            templateUrl: 'modules/profile/templates/addimportantmenutitem.dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                workspace: workspace,
                addImportantMenuItemsLabel: $scope.trns.addImportantMenuItems,
                chooseIconLabel: $scope.trns.chooseIcon,
                selectedItem: selectedItem
            }
        }).then(function (selectedItemToPush) {
            if (selectedItemToPush) {
                selectedItemToPush.xorder = workspace.importantMenuItems.length;
                workspace.importantMenuItems.push(selectedItemToPush);
            }
        }, angular.noop);
    };

    self.importantMenuItemDown = function (importantMenuItems, index) {
        if (index < importantMenuItems.length - 1) {
            var toMoveItem = importantMenuItems[index];
            toMoveItem.xorder++;
            importantMenuItems[index] = importantMenuItems[index + 1];
            importantMenuItems[index].xorder--;
            importantMenuItems[index + 1] = toMoveItem;
        }
    };

    self.importantMenuItemUp = function (importantMenuItems, index) {
        if (index > 0) {
            var toMoveItem = importantMenuItems[index];
            toMoveItem.xorder--;
            importantMenuItems[index] = importantMenuItems[index - 1];
            importantMenuItems[index].xorder++;
            importantMenuItems[index - 1] = toMoveItem;
        }
    };

    self.showPasswordChange = function (event) {
        $mdDialog.show({
                controller: "PasswordChangeCtrl",
                templateUrl: 'modules/profile/templates/password-change.tmpl.html',
                targetEvent: event,
                clickOutsideToClose: false,
                hasBackdrop: true,
                disableParentScroll: true
            }
        );
    };

    self.setAllSettings = function (newValue) {
        angular.forEach($scope.data.messageSettings.configMessages, function(message) {
            self.setViewTypeSettings(message, newValue);
        });
    };

    self.setViewTypeSettings = function (configMessage, newValue) {
        angular.forEach(configMessage.configMessages, function (type) {
            if (!type.forceMail && (newValue !== 3 || !type.notAllowedToSuppress)) {
                type.msgNotification = newValue;
            }
        });
    };
    
    function canRevokeTermsOfUseConsent() {
        if ($scope.data.termsOfUseData && $scope.data.termsOfUseData.termsOfUse.length > 0) {
            return $scope.data.termsOfUseData.termsOfUse.some(function (termOfUse) {
                return termOfUse.revokeConsent.value;
            });
        } else {
            return false;
        }
    }

    self.revokeTermsOfUseConsentDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.revokeTermsOfUseConsent, event, TranslationService.get("warning"),
            $scope.trns.termsOfUseRevokeConsentButton, TranslationService.get("abort"), $scope.trns.termsOfUseRevokeConsentQuestion);
    };

    self.revokeTermsOfUseConsent = function () {
        var ids = [];
        angular.forEach($scope.data.termsOfUseData.termsOfUse, function (termOfUse) {
            if (termOfUse.revokeConsent.value) {
                ids.push(termOfUse.touId);
            }
        });

        if (ids.length > 0) {
            dataGen.postAsForm({}, {ids: ids}, "/termsofuse/revokeConsent").then(function () {
                LoginService.logout();
            });
        }
    };

    self.showAPITokenDialog = function () {
        $mdDialog.show({
            controller: "APITokenCreationCtrl",
            controllerAs: "apiTokenCreationCtrl",
            templateUrl: "modules/profile/templates/apitokencreation.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            multiple: true
        });
    };

    self.getShortString = function (url){
        if(!url){
            return "";
        }
        const parts = url.split("/").filter(Boolean);
        return parts.length ? parts[parts.length - 1] : url;
    }
    
    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: canSave,
                params: {
                    form: $scope.dialogData,
                }
            },
            {
                label: $scope.trns.changePassword,
                action: self.showPasswordChange,
                type: 'dialogaction',
                condition: canChangePassword
            },
            {
                label: $scope.trns.addresses,
                linkFunction: getUserAddressListLink,
                type: 'link'
            },
            {
                label: $scope.trns.filters,
                linkFunction: getUserFilterListLink,
                type: 'link'
            },
            {
                label: $scope.trns.termsOfUseRevokeConsentButton,
                action: self.revokeTermsOfUseConsentDialog,
                type: 'dialogaction',
                condition: canRevokeTermsOfUseConsent
            },
            {
                label: $scope.trns.printUserSelfDisclosure,
                type: 'print',
                condition: canPrint,
                params: {
                    printToken: $scope.printTokens.profile
                }
            },
            {
                label: $scope.trns.apiToken,
                action: self.showAPITokenDialog,
                type: 'dialogaction',
                process: 'APIUser'
            }

        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canSave() {
        return !$scope.data.isActingUser
    }

    function canChangePassword() {
        return $scope.data.canChangePassword && !$scope.data.isActingUser;
    }

    function getUserAddressListLink() {
        return "useraddresslist";
    }

    function getUserFilterListLink() {
        return "userfilterlist";
    }

    function canPrint() {
        return $scope.data.isUserSelfDisclosureEnabled;
    }
}